import { render, staticRenderFns } from "./OpsiyonListesi.vue?vue&type=template&id=06f68b3c&scoped=true&"
import script from "./OpsiyonListesi.vue?vue&type=script&lang=js&"
export * from "./OpsiyonListesi.vue?vue&type=script&lang=js&"
import style0 from "./OpsiyonListesi.vue?vue&type=style&index=0&id=06f68b3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f68b3c",
  null
  
)

export default component.exports